module.exports = __webpack_public_path__ + "img/about.d4974bef.jpg";